import { IconProps, iconColor } from './IconProps'

import styles from './Icons.module.scss'

export function BreadcrumbHomeIcon(props: IconProps): JSX.Element {
  const { size = 12 } = props

  const { width = size, height = size } = props

  return (
    <svg {...props} width={width} height={height} viewBox='0 0 12 13' fill='none'>
      <path
        d='M11.7069 5.79266L6.70688 0.792662C6.51936 0.605267 6.26511 0.5 6.00001 0.5C5.7349 0.5 5.48065 0.605267 5.29313 0.792662L0.293131 5.79266C0.199822 5.88528 0.125855 5.99552 0.0755335 6.11698C0.0252116 6.23844 -0.00046166 6.36869 6.28343e-06 6.50016V12.5002C6.28343e-06 12.6328 0.0526848 12.7599 0.146453 12.8537C0.240221 12.9475 0.367398 13.0002 0.500006 13.0002H4.50001C4.63261 13.0002 4.75979 12.9475 4.85356 12.8537C4.94733 12.7599 5.00001 12.6328 5.00001 12.5002V9.00016H7.00001V12.5002C7.00001 12.6328 7.05268 12.7599 7.14645 12.8537C7.24022 12.9475 7.3674 13.0002 7.50001 13.0002H11.5C11.6326 13.0002 11.7598 12.9475 11.8536 12.8537C11.9473 12.7599 12 12.6328 12 12.5002V6.50016C12.0005 6.36869 11.9748 6.23844 11.9245 6.11698C11.8742 5.99552 11.8002 5.88528 11.7069 5.79266ZM11 12.0002H8.00001V8.50016C8.00001 8.36755 7.94733 8.24038 7.85356 8.14661C7.75979 8.05284 7.63261 8.00016 7.50001 8.00016H4.50001C4.3674 8.00016 4.24022 8.05284 4.14645 8.14661C4.05268 8.24038 4.00001 8.36755 4.00001 8.50016V12.0002H1.00001V6.50016L6.00001 1.50016L11 6.50016V12.0002Z'
        fill={props.color ? styles[props.color] : iconColor(props)}
      />
    </svg>
  )
}
